import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, toHandlers as _toHandlers, mergeProps as _mergeProps, withCtx as _withCtx, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-lg-12" }
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = /*#__PURE__*/_createVNode("form", {
  class: "form-horizontal",
  action: "",
  method: "post"
}, [
  /*#__PURE__*/_createVNode("div", { class: "form-group row" }),
  /*#__PURE__*/_createVNode("div", { class: "form-group row" })
], -1)
const _hoisted_5 = { class: "table-responsive" }
const _hoisted_6 = { class: "table table-responsive-sm table-bordered table-striped table-sm" }
const _hoisted_7 = /*#__PURE__*/_createVNode("th", { scope: "col" }, "신고여부(기능추가필요)", -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("th", { scope: "col" }, "사용자명", -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("th", { scope: "col" }, "이미지", -1)
const _hoisted_10 = { scope: "col" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" 댓글 ")
const _hoisted_12 = { key: 0 }
const _hoisted_13 = {
  key: 0,
  class: "c-icon"
}
const _hoisted_14 = /*#__PURE__*/_createVNode("use", { "xlink:href": "/assets/icons/sprites/free.svg#cil-arrow-top" }, null, -1)
const _hoisted_15 = {
  key: 1,
  class: "c-icon"
}
const _hoisted_16 = /*#__PURE__*/_createVNode("use", { "xlink:href": "/assets/icons/sprites/free.svg#cil-arrow-bottom" }, null, -1)
const _hoisted_17 = { scope: "col" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" 좋아요 ")
const _hoisted_19 = { key: 0 }
const _hoisted_20 = {
  key: 0,
  class: "c-icon"
}
const _hoisted_21 = /*#__PURE__*/_createVNode("use", { "xlink:href": "/assets/icons/sprites/free.svg#cil-arrow-top" }, null, -1)
const _hoisted_22 = {
  key: 1,
  class: "c-icon"
}
const _hoisted_23 = /*#__PURE__*/_createVNode("use", { "xlink:href": "/assets/icons/sprites/free.svg#cil-arrow-bottom" }, null, -1)
const _hoisted_24 = { scope: "col" }
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" 공유 ")
const _hoisted_26 = { key: 0 }
const _hoisted_27 = {
  key: 0,
  class: "c-icon"
}
const _hoisted_28 = /*#__PURE__*/_createVNode("use", { "xlink:href": "/assets/icons/sprites/free.svg#cil-arrow-top" }, null, -1)
const _hoisted_29 = {
  key: 1,
  class: "c-icon"
}
const _hoisted_30 = /*#__PURE__*/_createVNode("use", { "xlink:href": "/assets/icons/sprites/free.svg#cil-arrow-bottom" }, null, -1)
const _hoisted_31 = /*#__PURE__*/_createVNode("th", { scope: "col" }, "베스트 제외", -1)
const _hoisted_32 = /*#__PURE__*/_createVNode("th", { scope: "col" }, "상단 고정", -1)
const _hoisted_33 = { scope: "col" }
const _hoisted_34 = /*#__PURE__*/_createTextVNode(" 생성일자 ")
const _hoisted_35 = { key: 0 }
const _hoisted_36 = {
  key: 0,
  class: "c-icon"
}
const _hoisted_37 = /*#__PURE__*/_createVNode("use", { "xlink:href": "/assets/icons/sprites/free.svg#cil-arrow-top" }, null, -1)
const _hoisted_38 = {
  key: 1,
  class: "c-icon"
}
const _hoisted_39 = /*#__PURE__*/_createVNode("use", { "xlink:href": "/assets/icons/sprites/free.svg#cil-arrow-bottom" }, null, -1)
const _hoisted_40 = /*#__PURE__*/_createVNode("th", { scope: "col" }, "삭제일자", -1)
const _hoisted_41 = /*#__PURE__*/_createVNode("th", { scope: "col" }, "설정", -1)
const _hoisted_42 = { class: "text-center" }
const _hoisted_43 = {
  key: 0,
  class: "text-danger is_report"
}
const _hoisted_44 = /*#__PURE__*/_createVNode("strong", null, "UID: ", -1)
const _hoisted_45 = /*#__PURE__*/_createVNode("strong", null, "Email: ", -1)
const _hoisted_46 = /*#__PURE__*/_createVNode("svg", { class: "c-icon c-icon-lg" }, [
  /*#__PURE__*/_createVNode("use", { "xlink:href": "/assets/icons/sprites/free.svg#cil-info" })
], -1)
const _hoisted_47 = /*#__PURE__*/_createTextVNode(" More info ")
const _hoisted_48 = { key: 1 }
const _hoisted_49 = { key: 0 }
const _hoisted_50 = { key: 1 }
const _hoisted_51 = { key: 0 }
const _hoisted_52 = { key: 1 }
const _hoisted_53 = { class: "c-switch c-switch-pill c-switch-primary" }
const _hoisted_54 = /*#__PURE__*/_createVNode("span", { class: "c-switch-slider" }, null, -1)
const _hoisted_55 = { class: "c-switch c-switch-pill c-switch-primary" }
const _hoisted_56 = /*#__PURE__*/_createVNode("span", { class: "c-switch-slider" }, null, -1)
const _hoisted_57 = { key: 0 }
const _hoisted_58 = { key: 1 }
const _hoisted_59 = /*#__PURE__*/_createVNode("svg", { class: "c-icon c-icon-lg" }, [
  /*#__PURE__*/_createVNode("use", { "xlink:href": "/assets/icons/sprites/free.svg#cil-magnifying-glass" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CButton = _resolveComponent("CButton")
  const _component_CPopover = _resolveComponent("CPopover")
  const _component_PaginationV2 = _resolveComponent("PaginationV2")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", {
        class: ["card", { loading: _ctx.loading }]
      }, [
        _createVNode("div", _hoisted_3, [
          _hoisted_4,
          _createVNode("div", _hoisted_5, [
            _createVNode("table", _hoisted_6, [
              _createVNode("thead", null, [
                _createVNode("tr", null, [
                  _hoisted_7,
                  _hoisted_8,
                  _hoisted_9,
                  _createVNode("th", _hoisted_10, [
                    _createVNode("a", {
                      href: "javascript:void(0)",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.sortHandler('comments_count')))
                    }, [
                      _hoisted_11,
                      (_ctx.orderBy == 'comments_count')
                        ? (_openBlock(), _createBlock("span", _hoisted_12, [
                            (_ctx.orderType === 'asc')
                              ? (_openBlock(), _createBlock("svg", _hoisted_13, [
                                  _hoisted_14
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.orderType === 'desc')
                              ? (_openBlock(), _createBlock("svg", _hoisted_15, [
                                  _hoisted_16
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createVNode("th", _hoisted_17, [
                    _createVNode("a", {
                      href: "javascript:void(0)",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.sortHandler('likes_count')))
                    }, [
                      _hoisted_18,
                      (_ctx.orderBy == 'likes_count')
                        ? (_openBlock(), _createBlock("span", _hoisted_19, [
                            (_ctx.orderType === 'asc')
                              ? (_openBlock(), _createBlock("svg", _hoisted_20, [
                                  _hoisted_21
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.orderType === 'desc')
                              ? (_openBlock(), _createBlock("svg", _hoisted_22, [
                                  _hoisted_23
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createVNode("th", _hoisted_24, [
                    _createVNode("a", {
                      href: "javascript:void(0)",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.sortHandler('sharing_number')))
                    }, [
                      _hoisted_25,
                      (_ctx.orderBy == 'sharing_number')
                        ? (_openBlock(), _createBlock("span", _hoisted_26, [
                            (_ctx.orderType === 'asc')
                              ? (_openBlock(), _createBlock("svg", _hoisted_27, [
                                  _hoisted_28
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.orderType === 'desc')
                              ? (_openBlock(), _createBlock("svg", _hoisted_29, [
                                  _hoisted_30
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _hoisted_31,
                  _hoisted_32,
                  _createVNode("th", _hoisted_33, [
                    _createVNode("a", {
                      href: "javascript:void(0)",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.sortHandler('created_at')))
                    }, [
                      _hoisted_34,
                      (_ctx.orderBy == 'created_at')
                        ? (_openBlock(), _createBlock("span", _hoisted_35, [
                            (_ctx.orderType === 'asc')
                              ? (_openBlock(), _createBlock("svg", _hoisted_36, [
                                  _hoisted_37
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.orderType === 'desc')
                              ? (_openBlock(), _createBlock("svg", _hoisted_38, [
                                  _hoisted_39
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _hoisted_40,
                  _hoisted_41
                ])
              ]),
              _createVNode("tbody", null, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.fishingGrams, (item) => {
                  return (_openBlock(), _createBlock("tr", {
                    key: item.id,
                    class: { best: _ctx.isBestData(item.id) }
                  }, [
                    _createVNode("td", _hoisted_42, [
                      (item.has_report_comments)
                        ? (_openBlock(), _createBlock("span", _hoisted_43, "⚠️"))
                        : _createCommentVNode("", true)
                    ]),
                    _createVNode("td", null, [
                      _createVNode(_component_CPopover, {
                        placement: "right",
                        trigger: "click",
                        visible: false
                      }, {
                        toggler: _withCtx(({ on }) => [
                          _createVNode(_component_CButton, _mergeProps({
                            color: "link",
                            size: "sm"
                          }, _toHandlers(on)), {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.nick_name), 1)
                            ]),
                            _: 2
                          }, 1040)
                        ]),
                        content: _withCtx(() => [
                          _createVNode("p", null, [
                            _hoisted_44,
                            _createTextVNode(" " + _toDisplayString(item.uid), 1)
                          ]),
                          _createVNode("p", null, [
                            _hoisted_45,
                            _createTextVNode(" " + _toDisplayString(item.email_address), 1)
                          ])
                        ]),
                        title: _withCtx(() => [
                          _hoisted_46,
                          _hoisted_47
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _createVNode("td", null, [
                      (item.images[0].length)
                        ? (_openBlock(), _createBlock("img", {
                            key: 0,
                            class: "fishing-gram-thumb",
                            src: item.images[0] + '?w=150',
                            height: "80",
                            onClick: ($event: any) => (_ctx.viewDetail(item.id))
                          }, null, 8, ["src", "onClick"]))
                        : (_openBlock(), _createBlock("span", _hoisted_48, " - "))
                    ]),
                    _createVNode("td", null, [
                      _createVNode("span", null, _toDisplayString(item.comments_count ?? 0), 1)
                    ]),
                    _createVNode("td", null, [
                      (item.likes)
                        ? (_openBlock(), _createBlock("span", _hoisted_49, _toDisplayString(item.likes_count ?? 0), 1))
                        : (_openBlock(), _createBlock("span", _hoisted_50, "0"))
                    ]),
                    _createVNode("td", null, [
                      (item.sharing_number)
                        ? (_openBlock(), _createBlock("span", _hoisted_51, _toDisplayString(item.sharing_number), 1))
                        : (_openBlock(), _createBlock("span", _hoisted_52, "0"))
                    ]),
                    _createVNode("td", null, [
                      _createVNode("label", _hoisted_53, [
                        _withDirectives(_createVNode("input", {
                          onChange: ($event: any) => (_ctx.changeShowHandler(item.id, $event)),
                          type: "checkbox",
                          class: "c-switch-input",
                          "onUpdate:modelValue": ($event: any) => (item.ban = $event)
                        }, null, 40, ["onChange", "onUpdate:modelValue"]), [
                          [_vModelCheckbox, item.ban]
                        ]),
                        _hoisted_54
                      ])
                    ]),
                    _createVNode("td", null, [
                      _createVNode("label", _hoisted_55, [
                        _withDirectives(_createVNode("input", {
                          onChange: ($event: any) => (_ctx.changeFixHomeHandler(item.id, $event)),
                          type: "checkbox",
                          class: "c-switch-input",
                          "onUpdate:modelValue": ($event: any) => (item.fix_home = $event)
                        }, null, 40, ["onChange", "onUpdate:modelValue"]), [
                          [_vModelCheckbox, item.fix_home]
                        ]),
                        _hoisted_56
                      ])
                    ]),
                    _createVNode("td", null, _toDisplayString(_ctx.dateTimeHelper.timestampToDateTime(item.created_at)), 1),
                    _createVNode("td", null, [
                      (item.deleted_at !== 0)
                        ? (_openBlock(), _createBlock("span", _hoisted_57, _toDisplayString(_ctx.dateTimeHelper.timestampToDateTime(item.deleted_at)), 1))
                        : (_openBlock(), _createBlock("span", _hoisted_58, "-"))
                    ]),
                    _createVNode("th", null, [
                      _createVNode("button", {
                        class: "btn btn-btn-warning",
                        disabled: _ctx.loading,
                        type: "button",
                        onClick: ($event: any) => (_ctx.viewDetail(item.id))
                      }, [
                        _createVNode("span", {
                          class: { 'text-danger': !_ctx.loading }
                        }, [
                          _hoisted_59
                        ], 2)
                      ], 8, ["disabled", "onClick"])
                    ])
                  ], 2))
                }), 128))
              ])
            ])
          ]),
          _createVNode(_component_PaginationV2, {
            "data-model": _ctx.FishingGramsBestCandidatesModel,
            "order-options": _ctx.orderOptions,
            "filter-conditions": _ctx.filterConditions,
            onDataChanged: _ctx.updateData,
            onIsLoading: _ctx.isLoading,
            limit: _ctx.perpage
          }, null, 8, ["data-model", "order-options", "filter-conditions", "onDataChanged", "onIsLoading", "limit"])
        ])
      ], 2)
    ])
  ]))
}